import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';

/**
 * Surfaces backend authorization denials (HTTP 403) as a friendly toast instead of a silent
 * failure or a generic error. The backend is the source of truth for campaign-role enforcement
 * (Tier 2/3); this gives the user a clear "you don't have permission" message when a request they
 * were able to attempt (e.g. because the UI hadn't hidden a control) is rejected server-side.
 *
 * 401 (unauthenticated) is handled separately by logoutInterceptor. This interceptor re-throws so
 * component-level error handling still runs.
 */
export const forbiddenInterceptor: HttpInterceptorFn = (req, next) => {
    const messageService = inject(MessageService);

    return next(req).pipe(
        catchError((error) => {
            if (error.status === 403) {
                messageService.add({
                    severity: 'error',
                    summary: 'Permission denied',
                    detail: "You don't have permission to perform this action.",
                    life: 5000
                });
            }
            return throwError(() => error);
        })
    );
};
